var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveJobsDashboardIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11732_89095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.75C10 2.57125 10 1.9825 9.63375 1.61625C9.2675 1.25 8.67875 1.25 7.5 1.25C6.32125 1.25 5.7325 1.25 5.36625 1.61625C5 1.9825 5 2.57125 5 3.75M1.25 8.75C1.25 6.39312 1.25 5.21437 1.9825 4.4825C2.715 3.75062 3.89312 3.75 6.25 3.75H8.75C11.1069 3.75 12.2856 3.75 13.0175 4.4825C13.7494 5.215 13.75 6.39312 13.75 8.75C13.75 11.1069 13.75 12.2856 13.0175 13.0175C12.285 13.7494 11.1069 13.75 8.75 13.75H6.25C3.89312 13.75 2.71437 13.75 1.9825 13.0175C1.25062 12.285 1.25 11.1069 1.25 8.75Z",
    stroke: "#0FD056",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.625C10.625 5.79076 10.5592 5.94973 10.4419 6.06694C10.3247 6.18415 10.1658 6.25 10 6.25C9.83424 6.25 9.67527 6.18415 9.55806 6.06694C9.44085 5.94973 9.375 5.79076 9.375 5.625C9.375 5.45924 9.44085 5.30027 9.55806 5.18306C9.67527 5.06585 9.83424 5 10 5C10.1658 5 10.3247 5.06585 10.4419 5.18306C10.5592 5.30027 10.625 5.45924 10.625 5.625ZM5.625 5.625C5.625 5.79076 5.55915 5.94973 5.44194 6.06694C5.32473 6.18415 5.16576 6.25 5 6.25C4.83424 6.25 4.67527 6.18415 4.55806 6.06694C4.44085 5.94973 4.375 5.79076 4.375 5.625C4.375 5.45924 4.44085 5.30027 4.55806 5.18306C4.67527 5.06585 4.83424 5 5 5C5.16576 5 5.32473 5.06585 5.44194 5.18306C5.55915 5.30027 5.625 5.45924 5.625 5.625Z",
    fill: "#0FD056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11732_89095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveJobsDashboardIconDark);
export default __webpack_public_path__ + "static/media/active-jobs-dashboard-icon-dark.e53a6a94701330fb1b3d0c1cefbb33cd.svg";
export { ForwardRef as ReactComponent };